import "./IvError.css";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Modal, Table, Button } from "react-bootstrap";
import { getIvDataIndex, getIvFieldValue } from "../../utils/ivErrorDataUtils";

const 운전상태맵 = {
  0x0000: "대기",
  0x0001: "정상 운전",
  0x0002: "고장",
};

const 운전상태모달데이터 = {
  title: "0234 운전 상태",
  rows: [
    { value: 0x0000, label: "대기" },
    { value: 0x0001, label: "정상 운전" },
    { value: 0x0002, label: "고장" },
  ],
};

const 마스터에러모달데이터 = {
  title: "0220 에러 코드",
  rows: [
    { bit: "Bit31", desc: "내부 통신 실패" },
    { bit: "Bit30", desc: "EEPROM 읽기/쓰기 실패" },
    { bit: "Bit29", desc: "주파수 이상(Fac Failure)" },
    { bit: "Bit28", desc: "미정의" },
    { bit: "Bit27", desc: "미정의" },
    { bit: "Bit26", desc: "미정의" },
    { bit: "Bit25", desc: "릴레이 점검 실패" },
    { bit: "Bit24", desc: "미정의" },
    { bit: "Bit23", desc: "계통 전압 일치성 오류" },
    { bit: "Bit22", desc: "계통 주파수 일치성 오류" },
    { bit: "Bit21", desc: "통신 보드 일치성 오류" },
    { bit: "Bit20", desc: "모델 불일치" },
    { bit: "Bit19", desc: "누설 전류 과다" },
    { bit: "Bit18", desc: "절연 저항 이상" },
    { bit: "Bit17", desc: "계통 전압 이상" },
    { bit: "Bit16", desc: "외부 팬 고장" },
    { bit: "Bit15", desc: "GFCI 장치 점검 실패" },
    { bit: "Bit14", desc: "미정의" },
    { bit: "Bit13", desc: "과온" },
    { bit: "Bit12", desc: "팬 고장" },
    { bit: "Bit11", desc: "DC 버스 고전압" },
    { bit: "Bit10", desc: "접지 전류 이상" },
    { bit: "Bit9", desc: "계통 상실" },
    { bit: "Bit8", desc: "AC HCT 오류" },
    { bit: "Bit7", desc: "릴레이 장치 오류" },
    { bit: "Bit6", desc: "GFCI 장치 오류" },
    { bit: "Bit5", desc: "DC 버스 저전압" },
    { bit: "Bit4", desc: "미정의" },
    { bit: "Bit3", desc: "미정의" },
    { bit: "Bit2", desc: "기준 전압 점검 실패" },
    { bit: "Bit1", desc: "AC HCT 점검 실패" },
    { bit: "Bit0", desc: "미정의" },
  ],
};

const parseBitFlags32 = (value) => {
  const flags = {};
  if (typeof value !== "number") return flags;
  for (let i = 0; i < 32; i++) {
    flags[`Bit${i}`] = (value & (1 << i)) !== 0;
  }
  return flags;
};

const 운전상태이상여부 = (stateValue) => {
  if (typeof stateValue !== "number") return false;
  return stateValue !== 0x0000 && stateValue !== 0x0001;
};

const 에러이상여부 = (errorValue) => {
  if (typeof errorValue !== "number") return false;
  return errorValue !== 0;
};

const Goodwe60KError = ({ SelInverter }) => {
  const ivData = useSelector((state) => state.ivData || {});

  const [modalConfig, setModalConfig] = useState(null);
  const dataIndex = getIvDataIndex(ivData, SelInverter);

  const getFieldValue = (key) => {
    return getIvFieldValue(ivData, key, SelInverter);
  };

  const 운전상태 = getFieldValue("state");      // 0234
  const 마스터에러 = getFieldValue("fault0");    // 0220 Error Code
  const 마스터에러비트 = parseBitFlags32(마스터에러);

  const renderStateModal = () => {
    const modal = 운전상태모달데이터;
    return (
      <Modal show={!!modalConfig} onHide={() => setModalConfig(null)} size="md">
        <Modal.Header closeButton>
          <Modal.Title>{modal.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Table striped bordered size="sm">
            <thead>
              <tr>
                <th>값</th>
                <th>설명</th>
              </tr>
            </thead>
            <tbody>
              {modal.rows.map((row, idx) => {
                const isActive = row.value === 운전상태;
                return (
                  <tr key={idx} className={isActive ? "active-row" : ""}>
                    <td>{row.value}</td>
                    <td>{row.label}</td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setModalConfig(null)}>
            닫기
          </Button>
        </Modal.Footer>
      </Modal>
    );
  };

  const renderBitModal = () => {
    if (!modalConfig || modalConfig.type !== "bit") return null;

    const { modal, bits } = modalConfig;

    return (
      <Modal show={!!modalConfig} onHide={() => setModalConfig(null)} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>{modal.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Table striped bordered size="sm">
            <thead>
              <tr>
                <th>비트</th>
                <th>설명</th>
              </tr>
            </thead>
            <tbody>
              {modal.rows.map((row, idx) => {
                const isActive = bits[row.bit];
                return (
                  <tr key={idx} className={isActive ? "active-row" : ""}>
                    <td>{row.bit}</td>
                    <td>{row.desc}</td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setModalConfig(null)}>
            닫기
          </Button>
        </Modal.Footer>
      </Modal>
    );
  };

  if (dataIndex === -1) {
    return <div className="status-list-container">인버터를 선택하세요.</div>;
  }

  const 운전상태텍스트 =
    typeof 운전상태 === "number"
      ? 운전상태맵[운전상태] ?? `알 수 없음(${운전상태})`
      : "-";

  return (
    <div className="status-list-container">
      <div className="status-list">
        <div className="status-item">
          <span className="status-value">
            0234 운전 상태: {운전상태텍스트} ({운전상태 ?? "-"})
          </span>
          <button onClick={() => setModalConfig({ type: "state" })}>
            <span className={운전상태이상여부(운전상태) ? "blinking-icon" : ""}>
              {운전상태이상여부(운전상태) ? "🔴" : "🟢"}
            </span>
          </button>
        </div>

        <div className="status-item">
          <span className="status-value">
            0220 에러 코드: {마스터에러 ?? 0} (
            0x
            {typeof 마스터에러 === "number"
              ? 마스터에러.toString(16).toUpperCase()
              : "0"}
            )
          </span>
          <button
            onClick={() =>
              setModalConfig({
                type: "bit",
                modal: 마스터에러모달데이터,
                bits: 마스터에러비트,
              })
            }
          >
            <span className={에러이상여부(마스터에러) ? "blinking-icon" : ""}>
              {에러이상여부(마스터에러) ? "🔴" : "🟢"}
            </span>
          </button>
        </div>
      </div>

      {modalConfig?.type === "state" && renderStateModal()}
      {modalConfig?.type === "bit" && renderBitModal()}
    </div>
  );
};

export default Goodwe60KError;
